<script>
    import Icon from 'svelte-awesome'
    import { asterisk } from 'svelte-awesome/icons'

    export let required
</script>

{#if required}
    <Icon scale="0.5" data={asterisk} style="color: var(--bs-danger); position: relative; top: -0.3rem;" />
{/if}
